module.exports = __webpack_public_path__ + "fe5e39d09e8aa771d1ecf47aece2b73a.svg";